import { CUBE_DIMENSIONS } from "../../cube/dimensions";
import { createDimensionAnalysisView } from "./DimensionAnalysisView";

// ─────────────────────────────────────────────────────────────────────────────
// Analyse par Univers (Univers.dim)
// ─────────────────────────────────────────────────────────────────────────────
const UniversView = createDimensionAnalysisView({
  dimension: CUBE_DIMENSIONS.univers,
  type: "univers",
  title: "Analyse Univers",
  label: "Univers",
  pluralLabel: "Univers",
  one: "univers",
  many: "univers",
  searchPlaceholder: "Rechercher un univers…",
});

export default UniversView;
